import * as staticDataService from "services/staticDataService";

const brokerListSorter = (a, b) => {
  (a.company || "z").localeCompare(b.company || "z") ||
    (a.name || "z").localeCompare(b.name || "z");
};

/** Duplicates and sorts the given list **/
export const sortBrokerList = (brokerList) => {
  return [...(brokerList ?? [])].sort(brokerListSorter);
};

export const useGetSortedBrokerList = (name) => {
  const { data: brokers } = staticDataService.useConfigQuery(name);
  return sortBrokerList(brokers?.all ?? []);
};

export const useGetSortedBrokerListWithRefresh = (name) => {
  const {
    data: brokers,
    refetch: refreshBrokers,
  } = staticDataService.useConfigQuery(name);
  return [sortBrokerList(brokers?.all ?? []), refreshBrokers];
};

// Broker type names for use in api calls
export const RETAIL_BROKER_API_NAME = "retail_brokers";
export const SURPLUS_BROKER_API_NAME = "surplus_brokers";
export const PUNI_BROKER_API_NAME = "puni_brokers";
export const PRODUCER_BROKER_API_NAME = "producer_brokers";
export const WHOLESALE_BROKER_API_NAME = "wholesale_brokers";
